import moduleName from '../../services/module-name';

export default class {
    get tabs() {
        const tabModule = this.input.MAIN.find(e => e.meta && e.meta.name === moduleName.STORE_TABS);
        return tabModule ? tabModule.tabs : [];
    }
    get shopHeader() {
        return {
            categoryModule: this.input.TAB0.find(e =>
                // There's more than one version of STORE_CATEGORIES (ie, STORE_CATEGORIES_V2)
                e.meta && e.meta.name && e.meta.name.startsWith(moduleName.STORE_CATEGORIES)
            )
        };
    }
    get spinner() {
        return this.input.MAIN.find(e => e.meta && e.meta.name === moduleName.LOADING_SPINNER);
    }
    onCreate(input) {
        this.input = input;
        this.state = { selectedTabIndex: 0 };
    }
    onMount() {
        document.addEventListener('str-tab-change-event', (evt) => {
            const panelId = evt.detail.panelId;
            if (typeof panelId !== 'undefined') {
                this.state.selectedTabIndex = this.tabs.findIndex(tab => tab.panelId === panelId);
            }
        });
    }
}
